var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{attrs:{"name":"C3Tour","steps":((_vm.auth || {}).user || {}).isVendor
      ? _vm.tour.vendorTourSteps
      : _vm.tour.userTourSteps,"callbacks":_vm.tour.tourCallbacks,"options":{ highlight: true }}})
}
var staticRenderFns = []

export { render, staticRenderFns }